<template>
  <div>
    <page-header
      icon="mdi-chart-areaspline"
      :title="$t('routes.statistics')"
      :subtitle="$t('statistics_company_subtitle')"
    />

    <page-toolbar :searchable="false">
      <template #filters>
        <v-col cols="6" lg="auto">
          <date-picker v-model="date" color="white" />
        </v-col>
      </template>
    </page-toolbar>

    <div :class="device.isMobile ? 'px-0 mt-2' : 'px-2 mt-2'">
      <company-multi-restaurant-stats v-if="isMultiRestaurant" :date="date" />
      <company-group-stats v-else-if="isGroupType" :date="date" />
      <company-default-stats v-else :date="date" />
    </div>
  </div>
</template>

<script>
import CompanyDefaultStats from "./tabs/CompanyDefaultStats.vue";
import CompanyGroupStats from "./tabs/CompanyGroupStats.vue";
import CompanyMultiRestaurantStats from "./tabs/CompanyMultiRestaurantStats.vue";

export default {
  name: "CompanyStatistics",
  components: {
    CompanyDefaultStats,
    CompanyGroupStats,
    CompanyMultiRestaurantStats,
  },
  data() {
    return {
      date: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ],
    };
  },
  computed: {
    isMultiRestaurant() {
      return this.$store.state.company?.contract === 4;
    },
    isGroupType() {
      return this.$store.state.company?.type === "group";
    },
  },
};
</script>
